import gql from 'graphql-tag';

export default gql`
  mutation completeTask($id: ID!, $completed: Boolean) {
    completeTask(input: {id: $id, completed: $completed}) {
      id
      completed
      completedAt
      errors {
        path
        message
      }
    }
  }
`;
